<template>
  <table
    :class="$style['entrust-message-new']"
    cellspacing="0"
    border="1"
    style="margin: auto"
  >
    <tr>
      <td :rowspan="2" class="first-line">委托内容</td>
      <td :rowspan="2" class="examination-item">
        <div>
          检验检测项目：
          <div v-if="hasMoreSample">见附页</div>
          <template v-else>
            <div v-for="(item, i) in data.examinationItem" :key="i">
              {{ item }}
            </div>
          </template>
        </div>
        <!-- <div v-for="(item, i) in data.examinationItem" :key="i">{{ item }}</div> -->
      </td>
      <td>
        <div>检验检测依据：</div>
        <template v-if="hasMoreSample">见附页</template>
        <template v-else>
          <div v-for="(item, i) in data.examinationCredentials" :key="i">
            {{ item }}
          </div>
        </template>
      </td>
    </tr>
    <tr>
      <td class="deviate-ckeckbox">
        <div class="deviate-message">
          是否有偏离：
          <checkbox
            class="checkbox-deviate"
            :data="deviateOptions"
            :value="data.deviate_text"
          ></checkbox>
        </div>
        <!-- <div>
          <checkbox :data="deviateOptions" :value="data.deviate_text"></checkbox>
        </div> -->
        <div class="down-message">
          <div>详细情况描述</div>
          <div class="down-line" 
          :class="{ 'other-message': data.deviateInfo_show }">
            <template v-if="!data.deviateInfo_show">
            _________________________
            </template>
            <span class="sample-color" v-else>{{
              data.deviateInfo_show
            }}</span>
          </div>
        </div>
      </td>
    </tr>
  </table>
</template>
<script>
import { deviateOptions } from "./report-options";
import checkbox from "base/checkbox";
export default {
  props: {
    entrustContent: Array,
    data: {
      type: Object,
      default: function () {
        return {};
      },
    },
    examination: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  components: {
    checkbox,
  },
  data() {
    return {
      deviateOptions: deviateOptions,
    };
  },
  computed: {
    hasMoreSample() {
      return this.examination.length && this.examination.length > 1;
    },
  },
};
</script>
<style module lang="less">
.entrust-message-new {
  font-size: 13px;
  :global {
    td {
      vertical-align: top;
      text-align: left;
    }
    .first-line {
      width: 1em;
      vertical-align: inherit;
    }
    .deviate-ckeckbox {
      line-height: 25px;
      .deviate-message {
        display: flex;
      }
      .checkbox-deviate {
        width: auto;
      }
    }
    .down-message {
      display: flex;
      white-space: nowrap;
    }
    .down-line {
      position: relative;
    } 
    .other-message{
      margin-left: 10px;
    }
    // .sample-color {
    //   // position: absolute;
    // }
    .sample-color {
      white-space: normal;
      top: 0;
      text-decoration: underline;
    }
    .examination-item {
      width: 45%;
    }
  }
}
</style>
